import { render } from "./ClientManagement.vue?vue&type=template&id=1fed2ac7&scoped=true"
import script from "./ClientManagement.vue?vue&type=script&lang=js"
export * from "./ClientManagement.vue?vue&type=script&lang=js"

import "./ClientManagement.vue?vue&type=style&index=0&id=1fed2ac7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fed2ac7"]])

export default __exports__